import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MeetingDto } from '@interfaces/meetings/responses/meeting.response';
import { DateFormatterService } from '@services/helpers/date-formatter.service';
import { rotuloDoPeriodo } from '../../meetings-periods';

/** Qual card foi clicado. */
export type IndicadorDeMeetings = 'proximas' | 'bots' | 'sem-deal';

/**
 * Os três cards do topo da tela Meetings (card 3162, design `Meetings.dc.html`):
 *
 * - **Próximas:** as minhas reuniões futuras, com a próxima ("Próxima amanhã, 10:00"). Abre a aba.
 * - **Bots agendados:** as minhas próximas com bot. Abre Próximas filtrada por "com bot".
 * - **Sem deal vinculado:** todas as que eu vejo (minhas e de acesso geral) sem deal. Abre Todas com o
 *   filtro "Sem vínculo".
 *
 * Só apresenta: os números vêm da tela (o `total` de uma página de 1 do `GET meetings`).
 */
@Component({
  selector: 'app-meetings-kpis',
  standalone: true,
  templateUrl: './meetings-kpis.component.html',
  styleUrl: './meetings-kpis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingsKpisComponent {
  /** `null` = ainda carregando ou falhou: o número fica "—". */
  readonly totalProximas = input<number | null>(null);
  readonly proxima = input<MeetingDto | null>(null);
  readonly totalBots = input<number | null>(null);
  readonly totalSemDeal = input<number | null>(null);

  readonly escolher = output<IndicadorDeMeetings>();

  protected readonly apoioProximas = computed(() => {
    const proxima = this.proxima();
    if (!proxima) return this.totalProximas() === 0 ? 'Nenhuma agendada' : 'Suas reuniões futuras';

    const inicio = this.datas.parseDate(proxima.scheduledStartAt);
    if (!inicio) return 'Suas reuniões futuras';

    const hora = this.datas.formatDateTimeInFormat(proxima.scheduledStartAt, 'HH:mm');
    const periodo = rotuloDoPeriodo(inicio, this.datas.getTodayDate());
    if (periodo.chave === 'hoje' || periodo.chave === 'amanha') {
      return `Próxima ${periodo.rotulo.toLocaleLowerCase('pt-BR')}, ${hora}`;
    }
    return `Próxima em ${this.datas.formatDateTimeInFormat(proxima.scheduledStartAt, 'dd/MM')}, ${hora}`;
  });

  constructor(private readonly datas: DateFormatterService) {}
}
